import useGrupoStore from 'store/useGrupo'
import useSimulationStore from 'store/useSimulation'
import useBemStore from 'store/useBem'
import useCarrinhoStore from 'store/useCarrinho'
import useDocumentsStore from 'store/useDocuments'
import useGlobalStore from 'store/useGlobal'
import useClienteRegistroStore from 'store/useClienteRegistroStore'
import { useCreditoAnaliseStore } from 'store/useCreditoAnaliseStore'
import useUserInfoStore from 'store/useUser'

const useResetAllStores = () => {
  const { resetRegister } = useClienteRegistroStore((state) => state)
  const { resetGrupo } = useGrupoStore((state) => state)
  const { resetSimulation } = useSimulationStore((state) => state)
  const { resetBem } = useBemStore((state) => state)
  const { resetCarrinhoStore } = useCarrinhoStore((state) => state)
  const { resetDocumentsState } = useDocumentsStore((state) => state)
  const { resetGuid } = useGlobalStore((state) => state)
  const { resetCreditoAnalise } = useCreditoAnaliseStore((state) => state)
  const userInfo = useUserInfoStore((state) => state)

  const resetAll = (isResetUsers = false) => {
    resetGrupo()
    resetBem()
    resetSimulation()
    resetRegister()
    resetCarrinhoStore()
    resetDocumentsState()
    resetGuid()
    resetCreditoAnalise()
    isResetUsers && userInfo.resetState()
  }

  return resetAll
}

export default useResetAllStores
